//300 DPI

const formatSizes = [
	{
		"id": 15,
		"name": "Square Layflat 200x200mm",
		"units": "mm",
		"size": { "width": 403, "height": 203 },
		"pixels": { "width": 4760, "height": 2398 },
		"printSpecs": {
			"pdfPage": { "width": 403, "height": 203, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 403, "height": 203, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["LAY200X200", "LAY200X200SHDP", "LAY200X200SHPP", "LAY200X200LHDP", "LAY200X200LHPP", "LAY200X200PHDP", "LAY200X200PHPP"],
		"coverSize": {
			"width": 447, "height": 226,
			"pixels": { "width": 5280, "height": 2669 },
			"bleed": 10,
			"spine": 5
		}
	},
	{
		"id": 22,
		"name": "Square Layflat 300x300mm",
		"units": "mm",
		"size": { "width": 605, "height": 305 },
		"pixels": { "width": 7146, "height": 3602 },
		"printSpecs": {
			"pdfPage": { "width": 605, "height": 305, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 605, "height": 305, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["LAY300X300SH", "LAY300X300LH", "LAY300X300PH"],
		"coverSize": {
			"width": 647, "height": 326,
			"pixels": { "width": 7642, "height": 3850 },
			"bleed": 10,
			"spine": { "width": 308 }
		}
	},
	{
		"id": 7,
		"name": "A4 Landscape Lay-Flat",
		"units": "mm",
		"size": { "width": 583, "height": 203 },
		"pixels": { "width": 6886, "height": 2398 },
		"printSpecs": {
			"pdfPage": { "width": 583, "height": 203, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 583, "height": 203, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["LAYA4", "LAYA4LSH", "LAYA4LLH", "LAYA4LPH"],
		"coverSize": {
			"width": 627, "height": 236,
			"pixels": { "width": 7406, "height": 2787 },
			"bleed": 10,
			"spine": { "width": 310 }
		}
	},
	{
		"id": 25,
		"name": "A4 Portrait Lay-Flat",
		"units": "mm",
		"size": { "width": 425, "height": 305 },
		"pixels": { "width": 5020, "height": 3602 },
		"printSpecs": {
			"pdfPage": { "width": 425, "height": 305, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 425, "height": 305, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["LAYA4P", "LAYA4PSHDP", "LAYA4PSHPP", "LAYA4PLHDP", "LAYA4PLHPP", "LAYA4PPHDP", "LAYA4PPHPP"],
		"coverSize": {
			"width": 467, "height": 323,
			"pixels": { "width": 5516, "height": 3815 },
			"bleed": 10,
			"spine": 5
		}
	},
	{
		"id": 11,
		"name": "A3 Landscape Lay-Flat",
		"units": "mm",
		"size": { "width": 845, "height": 305 },
		"pixels": { "width": 9980, "height": 3602 },
		"printSpecs": {
			"pdfPage": { "width": 845, "height": 305, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 845, "height": 305, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["LAYA3", "LAYA3LSH", "LAYA3LPH", "LAYA3LLH"],
		"coverSize": {
			"width": 887, "height": 326,
			"pixels": { "width": 10476, "height": 3850 },
			"bleed": 10,
			"spine": { "width": 415 }
		}
	},
	{
		"id": 33,
		"name": "A4 Landscape Photobook",
		"units": "mm",
		"size": { "width": 303, "height": 216 },
		"pixels": { "width": 3579, "height": 2551 },
		"printSpecs": {
			"pdfPage": { "width": 303, "height": 216, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 303, "height": 216, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["A4L", "A4LSHMP", "A4LSHGFAP", "A4LLHMP", "A4LLHGFAP", "A4LPHMP", "A4LPHGFAP", "A4LLH"],
		"coverSize": {
			"width": 660, "height": 236,
			"pixels": { "width": 7795, "height": 2787 },
			"bleed": 10,
			"spine": { "width": 310 }
		}
	},
	{
		"id": 41,
		"name": "A4 Portrait Photobook",
		"units": "mm",
		"size": { "width": 216, "height": 303 },
		"pixels": { "width": 2551, "height": 3579 },
		"printSpecs": {
			"pdfPage": { "width": 216, "height": 303, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 216, "height": 303, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["A4P", "A4PPS", "A4PSH", "A4PLH", "A4PPH"],
		"coverSize": {
			"width": 480, "height": 323,
			"pixels": { "width": 5669, "height": 3815 },
			"bleed": 10,
			"spine": { "width": 309 }
		}
	},
	{
		"id": 46,
		"name": "Square Photobooks 120x120",
		"units": "mm",
		"size": { "width": 120, "height": 120 },
		"pixels": { "width": 1417, "height": 1417 },
		"printSpecs": {
			"pdfPage": { "width": 120, "height": 120, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 120, "height": 120, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["SP", "120X120SPPS", "200X200SPPS"],
		"coverSize": {
			"width": 280, "height": 140,
			"pixels": { "width": 3307, "height": 1654 },
			"bleed": 10,
			"spine": { "width": 125 }
		}
	},
	{
		"id": 49,
		"name": "Square Photobooks 200x200mm",
		"units": "mm",
		"size": { "width": 203, "height": 203 },
		"pixels": { "width": 2398, "height": 2398 },
		"printSpecs": {
			"pdfPage": { "width": 203, "height": 203, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 203, "height": 203, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["200X200SPSHMP", "200X200SPLHMP", "200X200SPPHMP"],
		"coverSize": {
			"width": 460, "height": 226,
			"pixels": { "width": 5433, "height": 2669 },
			"bleed": 10,
			"spine": { "width": 205 }
		}
	},
	{
		"id": 53,
		"name": "Square Photobooks 300x300mm",
		"units": "mm",
		"size": { "width": 306, "height": 306 },
		"pixels": { "width": 3614, "height": 3614 },
		"printSpecs": {
			"pdfPage": { "width": 306, "height": 306, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 306, "height": 306, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["300X300SPSHMP", "300X300SPLHMP", "300X300SPPHMP", "300X300SPLH"],
		"coverSize": {
			"width": 660, "height": 326,
			"pixels": { "width": 7795, "height": 3850 },
			"bleed": 10,
			"spine": { "width": 308 }
		}
	},
	{
		"id": 60,
		"name": "A5 Portrait Lay-Flat",
		"units": "mm",
		"size": { "width": 299, "height": 213 },
		"pixels": { "width": 3531, "height": 2516 },
		"printSpecs": {
			"pdfPage": { "width": 299, "height": 213, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 299, "height": 213, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["LAYA5P", "LAYA5"],
		"coverSize": {
			"width": 356, "height": 230,
			"pixels": { "width": 4205, "height": 2717 },
			"bleed": 10,
			"spine": 5
		}
	},
	{
		"id": 61,
		"name": "A4 Portrait Softcover",
		"units": "mm",
		"size": { "width": 213, "height": 303 },
		"pixels": { "width": 2516, "height": 3579 },
		"printSpecs": {
			"pdfPage": { "width": 213, "height": 303, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 213, "height": 303, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["A4P_SC"],
		"coverSize": {
			"width": 426.5, "height": 303,
			"pixels": { "width": 5037, "height": 3579 },
			"bleed": 10,
			"spine": 5
		}
	},
	{
		"id": 62,
		"name": "A3 Landscape Photobook",
		"units": "mm",
		"size": { "width": 410, "height": 303 },
		"pixels": { "width": 4843, "height": 3579 },
		"printSpecs": {
			"pdfPage": { "width": 410, "height": 303, "bleed": 3, "description": "Single pages in Multi Page PDF (No Spreads / No Crop Marks)" },
			"jpegSpread": { "width": 410, "height": 303, "bleed": 3, "description": "Single spreads as JPEG (RGB), No crop marks" }
		},
		"sku": ["A3L"],
		"coverSize": {
			"width": 882, "height": 326,
			"pixels": { "width": 10417, "height": 3850 },
			"bleed": 10,
			"spine": { "width": 415 }
		}
	}
]

export default formatSizes